/* Scroll-reveal system. Elements are only hidden after JS runs,
   so content is never invisible without JS. Respects reduced motion. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var SELECTORS = [
    '.aikyam-props__item',
    '.aikyam-symbols__header',
    '.aikyam-symbols__card',
    '.brand-story__text-inner',
    '.aikyam-meaning',
    '.card-wrapper'
  ].join(',');

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('aikyam-reveal--in');
          observer.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.1 }
  );

  function prime(scope) {
    var els = scope.querySelectorAll(SELECTORS);
    var batch = 0;
    els.forEach(function (el) {
      if (el.classList.contains('aikyam-reveal')) return;
      // Already on screen at load — don't hide it
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.85 && rect.bottom > 0) {
        return;
      }
      el.classList.add('aikyam-reveal');
      el.style.transitionDelay = (batch % 4) * 90 + 'ms';
      batch++;
      observer.observe(el);
    });
  }

  function init() {
    prime(document);
    // Re-prime when facets/AJAX replace the product grid
    var grid = document.getElementById('ProductGridContainer');
    if (grid && 'MutationObserver' in window) {
      new MutationObserver(function () {
        prime(grid);
      }).observe(grid, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
